import Language from "@/types/enums/language";

export interface IContact {
  first_name: string;
  last_name: string;
  gender: string;
  type: string;
  company_name?: string;
  company_type?: string;
  company_vat_code?: string;
  street: string;
  zipcode: string;
  city: string;
  country: string;
  country_name?: string;
  email?: string;
  phone?: string;
  language?: string;
  is_vip?: boolean;
  is_allowed_without_payment?: boolean;
}

export default class Contact {
  public firstName: string;
  public lastName: string;
  public gender: string;
  public type: string;
  public companyName: null | string;
  public companyType: null | string;
  public companyVatCode: null | string;
  public street: string;
  public zipcode: string;
  public city: string;
  public country: string;
  public countryName: null | string;
  public email: string;
  public phone: string;
  public language: string;
  public isVip: boolean;
  public isAllowedWithoutPayment: boolean;

  constructor(data: IContact) {
    this.firstName = data.first_name;
    this.lastName = data.last_name;
    this.gender = data.gender;
    this.type = Contact.normalizeType(data.type);
    this.companyName = data.company_name ?? null;
    this.companyType = data.company_type ?? null;
    this.companyVatCode = data.company_vat_code ?? null;
    this.street = data.street;
    this.zipcode = data.zipcode;
    this.city = data.city;
    this.country = data.country;
    this.countryName = data.country_name ?? null;
    this.email = data.email ?? "";
    this.phone = data.phone ?? "";
    this.language = data.language ?? Language.EN;
    this.isVip = data.is_vip ?? false;
    this.isAllowedWithoutPayment = data.is_allowed_without_payment ?? false;
  }

  toDTO(): IContact {
    return {
      first_name: this.firstName,
      last_name: this.lastName,
      gender: this.gender,
      type: this.type,
      company_name: this.companyName ?? undefined,
      company_type: this.companyType ?? undefined,
      company_vat_code: this.companyVatCode ?? undefined,
      street: this.street,
      zipcode: this.zipcode,
      city: this.city,
      country: this.country,
      country_name: this.countryName ?? undefined,
      email: this.email || undefined,
      phone: this.phone || undefined,
      language: this.language || undefined,
      is_vip: this.isVip || undefined,
      is_allowed_without_payment: this.isAllowedWithoutPayment || undefined
    };
  }

  public name(): string {
    return this.isBusiness()
      ? `${this.companyName ?? ""} ${this.companyType ?? ""}`.trim()
      : `${this.firstName ?? ""} ${this.lastName ?? ""}`.trim();
  }

  public isBusiness(): boolean { return this.type === "B"; }
  public isPrivate(): boolean { return this.type === "P"; }

  private static normalizeType(val?: string | null): "P" | "B" {
    const s = (val ?? "").toString().trim().toLowerCase();
    if (s === "b" || s === "business") return "B";
    if (s === "p" || s === "private") return "P";
    return "P";
  }
}
